export default __webpack_public_path__ + "static/media/ILPlatform_Robot.d2002b16.jpg";